import { render } from "./CardInfo.vue?vue&type=template&id=950d5310&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"

import "./CardInfo.vue?vue&type=style&index=0&id=950d5310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950d5310"]])

export default __exports__